import { useState, useEffect } from 'react';
import { useEventListener } from './use-event-listener.ts';

export const useFocusTrap = (options = { enabled: true }) => {
  const { enabled } = options;
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [previousFocus, setPreviousFocus] = useState<HTMLElement | null>(null);

  const focusableElements = (element: HTMLElement) =>
    element.querySelectorAll<HTMLElement>(
      "a, button, input, textarea, select, details, [tabindex]:not([tabindex='-1'])"
    );

  useEventListener(
    'keydown',
    (e: KeyboardEvent) => {
      if (element) {
        const focusable = focusableElements(element);

        const firstElement = focusable[0];
        const lastElement = focusable[focusable.length - 1];

        if (e.key === 'Tab') {
          if (e.shiftKey && document.activeElement === firstElement) {
            e.preventDefault();
            lastElement?.focus();
          } else if (!e.shiftKey && document.activeElement === lastElement) {
            e.preventDefault();
            firstElement?.focus();
          }
        }
      }
    },
    element || undefined,
    { enabled: enabled && !!element }
  );

  useEffect(() => {
    if (!enabled || !element) return;

    setPreviousFocus(document.activeElement as HTMLElement);

    const focusable = focusableElements(element);
    const firstElement = focusable[0];
    firstElement?.focus();

    return () => {
      previousFocus?.focus();
    };
  }, [enabled, element]);

  return { onElementRef: setElement };
};
